import { Link, NavLink, useLocation } from "react-router";
import { useState, useEffect } from "react";
import { classNames, QUOTE_TOKEN_RESOURCE_ADDRESS } from "~/lib/util";
import NetworkSelector from "../network-selector";
import Logo from "./logo";
import { useRdt } from "~/rdt/hooks/useRdt";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";

declare global {
  namespace JSX {
    interface IntrinsicElements {
      "radix-connect-button": React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
    }
  }
}

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showingPools, setShowingPools] = useState(false);
  const [showingTokens, setShowingTokens] = useState(false);
  const location = useLocation();
  const rdt = useRdt();

  // set button layout
  useEffect(() => {
    rdt?.buttonApi.setTheme("black");
    rdt?.buttonApi.setMode("dark");
  }, []);

  function toggleMenu() {
    setMenuOpen(!menuOpen);
  }

  function closeMenu() {
    if (!menuOpen) {
      return;
    }

    setMenuOpen(false);
  }

  return (
    <header className="sm:_backdrop-blur-xs sticky top-0 z-50 nav-header">
      <nav className="relative flex items-center justify-between px-4 pb-3 pt-6 xl:container xl:mx-auto xl:px-0">
        <button onClick={toggleMenu} className="h-4 w-8 lg:hidden">
          <ul className="flex h-4 flex-col justify-around">
            <li className={classNames(menuOpen ? "rot45deg" : "", "dark:bg-primary-100 relative h-0.5 bg-black duration-200 ease-in-out")}></li>
            <li className={classNames(menuOpen ? "rot-45deg" : "", "dark:bg-primary-100 relative h-0.5 bg-black duration-200 ease-in-out")}></li>
          </ul>
        </button>

        <Link to="/liquidity/add" className="flex justify-center">
          <Logo />
        </Link>

        <ul
          className={classNames(
            menuOpen ? "absolute left-0 top-20 flex" : "hidden",
            "nav-header bg-background-900/85 _backdrop-blur-lg w-full flex-col border-b border-white/[0.06] py-4 text-lg max-sm:h-screen max-sm:space-y-4 lg:border-none lg:flex lg:w-min lg:flex-row lg:space-y-0 lg:border-0 lg:bg-transparent lg:py-0 lg:text-base",
          )}
        >
          <li>
            <NavLink to="/swap" end
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? "text-primary-400 border-b-2 border-primary-400" : "text-[rgba(232,232,238,0.6)] hover:text-[#e8e8ee]") + " mx-4 block w-full pt-0.5 lg:w-min"}
            >
              Swap
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/liquidity/add"
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? "text-primary-400 border-b-2 border-primary-400" : "text-[rgba(232,232,238,0.6)] hover:text-[#e8e8ee]") + " mx-4 block w-full pt-0.5 lg:w-min"}
            >
              Liquidity
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/token/resource_rdx1t42hpqvsk4t42l6aw09hwphd2axvetp6gvas9ztue0p30f4hzdwxrp/staking"
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? "text-primary-400 border-b-2 border-primary-400" : "text-[rgba(232,232,238,0.6)] hover:text-[#e8e8ee]") + " mx-4 block w-full pt-0.5 lg:w-min"}
            >
              Staking
            </NavLink>

          </li>

          <li>
            <NavLink
              to="/liquidity/my"
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? "text-primary-400 border-b-2 border-primary-400" : "text-[rgba(232,232,238,0.6)] hover:text-[#e8e8ee]") + " mx-4 block w-full pt-0.5 lg:w-min"}
            >
              Portfolio
            </NavLink>
          </li>

          <li>
            <a
              href="https://reddicks.meme"
              onClick={closeMenu}
              className={"text-[rgba(232,232,238,0.6)] hover:text-[#e8e8ee] mx-4 flex w-full items-center justify-start border-b-2 pt-0.5 border-transparent lg:w-min"}
              target="_blank"
            >
              Reddicks
              <svg className="ml-1 size-4 text-gray-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path stroke-linecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
              </svg>
            </a>
          </li>

          <li>
            <a
              href="https://reddicks.meme/dckslap"
              onClick={closeMenu}
              className={"text-[rgba(232,232,238,0.6)] hover:text-[#e8e8ee] mx-4 flex w-full items-center justify-start border-b-2 pt-0.5 border-transparent lg:w-min"}
              target="_blank"
            >
              DCKSlap
              <svg className="ml-1 size-4 text-gray-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path stroke-linecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
              </svg>
            </a>
          </li>

        </ul>

        <div>
          {/* <NetworkSelector></NetworkSelector> */}

          <radix-connect-button />
        </div>
      </nav>
    </header>
  );
}
